export default __webpack_public_path__ + "static/media/boxicons.0f4528cf.woff";